function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Modifier from 'ember-modifier';
import { TextField } from 'field-kit';
import USDateFormatter from '@banking/ui/utils/field-kit-formatters/us-date-formatter';
export default class FormatDate extends Modifier {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "handler", void 0);
    _defineProperty(this, "fieldKit", void 0);
  }
  get callback() {
    return this.args.positional[0];
  }
  didInstall() {
    if (this.element.tagName.toUpperCase() !== 'MARKET-INPUT-TEXT') {
      throw new Error('The format-date modifier can only be applied to a market input text element.');
    }
    const element = this.element;
    this.handler = event => {
      // We can safely assume this event type since we know for certain the
      // element is a market-input-text.
      this.install(event, element);
    };
    element.addEventListener('marketInputDidLoad', this.handler);
  }
  willRemove() {
    const element = this.element;
    if (this.handler) {
      element.removeEventListener('marketInputDidLoad', this.handler);
      delete this.handler;
    }
    if (this.fieldKit) {
      this.fieldKit.destroy();
      delete this.fieldKit;
    }
  }
  install(event, element) {
    const input = event.detail.input;
    const formatter = new USDateFormatter();
    if (this.args.named.value) {
      element.value = formatter.format(this.args.named.value);
    }
    this.fieldKit = new TextField(input, formatter);
    const textDidChange = field => {
      const value = field.value();
      this.callback(value);
    };
    this.fieldKit.setDelegate({
      textDidChange
    });
  }
}